
/* ==========================================
   LMD STUDIO ★ STICKY ADD TO CART
   Shopify Ritual — Mobile only
   ========================================== */

(() => {
  const MOBILE_QUERY = "(max-width: 749px)";
  const media = window.matchMedia(MOBILE_QUERY);

  let sticky = null;
  let originalButton = null;
  let productForm = null;
  let observer = null;
  let mutationObserver = null;
  let resizeObserver = null;
  let refreshFrame = null;

  function isProductPage() {
    return document.body.classList.contains("template-product") ||
      window.location.pathname.startsWith("/products/");
  }

  function getOriginalButton() {
    return document.querySelector(
      ".buy-buttons-block product-form-component .add-to-cart-button"
    );
  }

  function getVariantInput() {
    return productForm?.querySelector('input[name="id"]');
  }

  function getProductTitle() {
    return document.querySelector(
      ".product-information h1, main h1"
    )?.textContent?.trim() || "LMD STUDIO";
  }

  function getSelectedSize() {
    const picker = document.querySelector(
      ".variant-picker .variant-option--lmd-size"
    );

    const checked = picker?.querySelector("input:checked");

    return checked?.value || "";
  }

  function getPrice() {
    const price = document.querySelector(
      ".product-information .price, .product-information [data-testid='price'], .product-information .price__current, .product-information .price-item--regular"
    );

    return price?.textContent?.trim() || "";
  }

  function isUnavailable() {
    return !originalButton ||
      originalButton.disabled ||
      originalButton.matches("[aria-disabled='true']") ||
      !getVariantInput()?.value;
  }

  function createSticky() {
    if (sticky) return;

    sticky = document.createElement("div");
    sticky.className = "lmd-sticky-cart";
    sticky.setAttribute("aria-label", "Compra rápida LMD");

    sticky.innerHTML = `
      <div class="lmd-sticky-cart__inner">
        <div class="lmd-sticky-cart__details">
          <span class="lmd-sticky-cart__eyebrow">LMD STUDIO ★</span>
          <span class="lmd-sticky-cart__title"></span>
          <span class="lmd-sticky-cart__meta"></span>
        </div>
        <button
          type="button"
          class="lmd-sticky-cart__button"
        >
          AGREGAR AL CARRITO ↗
        </button>
      </div>
    `;

    document.body.appendChild(sticky);

    sticky.querySelector("button").addEventListener("click", () => {
      const currentButton = getOriginalButton();

      if (!currentButton || isUnavailable()) return;

      currentButton.click();
    });
  }

  function syncSticky() {
    if (!sticky || !originalButton) return;

    const title = sticky.querySelector(".lmd-sticky-cart__title");
    const meta = sticky.querySelector(".lmd-sticky-cart__meta");
    const button = sticky.querySelector(".lmd-sticky-cart__button");

    title.textContent = getProductTitle();

    const size = getSelectedSize();
    const price = getPrice();

    meta.textContent = [price, size].filter(Boolean).join(" · ");

    const unavailable = isUnavailable();

    button.disabled = unavailable;
    button.textContent = unavailable
      ? "AGOTADO"
      : "AGREGAR AL CARRITO ↗";
  }

  function updateVisibility() {
    if (!sticky || !originalButton) return;

    if (!media.matches || isUnavailable() && !getVariantInput()) {
      sticky.classList.remove("is-visible");
      return;
    }

    const rect = originalButton.getBoundingClientRect();

    // Mostrar solo cuando el botón original
    // quedó por encima de la pantalla.
    const shouldShow = rect.bottom < 0;

    sticky.classList.toggle("is-visible", shouldShow);
  }

  function scheduleRefresh() {
    if (refreshFrame) return;

    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      originalButton = getOriginalButton();
      productForm = originalButton?.closest("form");

      syncSticky();
      updateVisibility();
    });
  }

  function init() {
    if (!isProductPage()) return;

    originalButton = getOriginalButton();

    if (!originalButton) return;

    productForm = originalButton.closest("form");

    createSticky();
    syncSticky();
    updateVisibility();

    window.addEventListener("scroll", updateVisibility, {
      passive: true
    });

    window.addEventListener("resize", scheduleRefresh, {
      passive: true
    });

    document.addEventListener("change", scheduleRefresh);

    document.addEventListener("variant:change", scheduleRefresh);

    document.addEventListener("shopify:section:load", scheduleRefresh);

    // Vigilar cambios en el formulario de Ritual
    mutationObserver = new MutationObserver(scheduleRefresh);

    mutationObserver.observe(
      document.querySelector("main") || document.body,
      {
        subtree: true,
        attributes: true,
        attributeFilter: [
          "disabled",
          "aria-disabled",
          "value",
          "checked"
        ]
      }
    );

    // Mantener la barra actualizada si
    // cambia el tamaño del botón original
    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(scheduleRefresh);
      resizeObserver.observe(originalButton);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
